import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, MenuItem, Button, Dialog, DialogContent, Typography } from '@mui/material';
import { sandboxApi } from '../../services/api';
import GenerationLoader from '../GenerationLoader';
import { useTranslation } from 'react-i18next';

const SandboxChoice = ({ token, userInfo, onClose }) => {
    const { t } = useTranslation();
    const [sandboxes, setSandboxes] = useState([]);
    const [selectedSandbox, setSelectedSandbox] = useState('');
    const [open, setOpen] = useState(false);
    const [prompt, setPrompt] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [processId, setProcessId] = useState(null);
    const [sandboxId, setSandboxId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const loadUserSandboxes = async () => {
            try {
                const userSandboxes = await sandboxApi.getActiveSandboxes(userInfo.id, token);
                setSandboxes(userSandboxes || []);
            } catch (error) {
                console.error('Error fetching sandboxes:', error);
                setSandboxes([]);
            }
        };

        loadUserSandboxes();
    }, [token, userInfo.id]);

    const handleSelectSandbox = (id) => {
        onClose();
        navigate(`/sandbox/${id}`);
    };

    const handleCreateSandbox = async () => {
        try {
            const data = await sandboxApi.startProcess(
                token,
                prompt,
                userInfo.id,
                'base',
                null    // нет существующей песочницы
            );
            setProcessId(data.process_id);
            setSandboxId(data.sandbox_id);
            setIsLoading(true);
        } catch (error) {
            console.error('Error creating sandbox:', error);
        }
    };

    const filteredSandboxes = sandboxes.filter(sandbox =>
        sandbox.name.toLowerCase().includes(selectedSandbox.toLowerCase())
    );

    // Если идет процесс генерации, показываем лоадер
    if (isLoading && processId && sandboxId) {
        return <GenerationLoader token={token} ProcessId={processId} SandboxId={sandboxId} />;
    }

    return (
        <Dialog
            open={true}
            onClose={onClose}
            PaperProps={{
                sx: {
                    backgroundColor: 'white',
                    boxShadow: 'none',
                    borderRadius: '16px',
                    padding: 0,
                    maxWidth: '400px',
                    width: '100%',
                    margin: 'auto',
                },
            }}
        >
            <DialogContent sx={{ padding: '24px' }}>
                <Typography variant="h5" gutterBottom>
                    {t('sandbox_choice.title')}
                </Typography>

                <TextField
                    select
                    fullWidth
                    value={selectedSandbox}
                    onChange={(e) => setSelectedSandbox(e.target.value)}
                    variant="outlined"
                    sx={{
                        marginBottom: '24px',
                        '.MuiSelect-select': {
                            paddingTop: '10px',
                            paddingBottom: '10px',
                        },
                    }}
                >
                    {filteredSandboxes.map(sandbox => (
                        <MenuItem
                            key={sandbox.id}
                            value={sandbox.id}
                            onClick={() => handleSelectSandbox(sandbox.id)}
                        >
                            {sandbox.name}
                        </MenuItem>
                    ))}
                </TextField>

                <Button
                    onClick={() => setOpen(true)}
                    variant="contained"
                    fullWidth
                    sx={{
                        backgroundColor: '#FF6F00',
                        color: 'white',
                        padding: '10px 0',
                        borderRadius: '8px',
                        fontWeight: 'bold',
                        '&:hover': { backgroundColor: '#E65100' },
                    }}
                >
                    {t('sandbox_choice.buttons.create_new')}
                </Button>

                <Dialog open={open} onClose={() => setOpen(false)}>
                    <DialogContent>
                        <Typography variant="h6" gutterBottom>
                            {t('sandbox_choice.prompt_dialog.title')}
                        </Typography>
                        <TextField
                            multiline
                            rows={5}
                            fullWidth
                            variant="outlined"
                            value={prompt}
                            onChange={(e) => setPrompt(e.target.value)}
                            placeholder={t('sandboxChoice.placeholder')}

                            sx={{ marginBottom: '16px' }}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleCreateSandbox}
                            fullWidth
                            sx={{
                                backgroundColor: '#FF6F00',
                                color: 'white',
                                padding: '10px 0',
                                borderRadius: '8px',
                                fontWeight: 'bold',
                                '&:hover': { backgroundColor: '#E65100' },
                            }}
                        >
                            {t('sandbox_choice.buttons.start_generation')}
                        </Button>
                    </DialogContent>
                </Dialog>
            </DialogContent>
        </Dialog>
    );
};

export default SandboxChoice;
